import { IOpenInterestSectionType } from "@domains/features/Markets/Futures/entities/iOpenIntrestAnalysis";
import createNamedWrapperReducer from "@frameworks/web/redux/feature/Markets/Equity/wrapperReducer";
import { combineReducers } from "redux";
import OpenInterest from "./openInterestCombinedReducer";
export default combineReducers({
    LongBuildup: createNamedWrapperReducer(OpenInterest, IOpenInterestSectionType.LongBuildup),
    LongUnwinding: createNamedWrapperReducer(OpenInterest, IOpenInterestSectionType.LongUnwinding),
    ShortBuildup: createNamedWrapperReducer(OpenInterest, IOpenInterestSectionType.ShortBuildup),
    ShortCovering: createNamedWrapperReducer(OpenInterest, IOpenInterestSectionType.ShortCovering),
});
